import React, { useEffect, useState } from "react";
import {
  CustomButton2,
  CustomHourMinutePiker,
  CustomIcon,
  CustomInput,
  CustomModal,
} from "../../../../components";
import Context from "../../../../context";
import "./index.scss";
import { Container, Row } from "react-bootstrap";
import Column from "../../../../components/CustomView/Column";
import { IItem, ITime } from "../../../../types/common.interface";
import CustomDropDownSearch from "../../../../components/CustomDropDownSearch";
import { WEEK_DAY } from "../../../../values/dropdownItems";

const Update = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, updateWorkTime, selectedWorkTime, loading } =
    React.useContext(Context.WorkTimeScreen);

  const [selectedDay, setSelectedDay] = useState<IItem>();
  const [endTime, setEndTime] = useState<ITime>();
  const [startTime, setStartTime] = useState<ITime>();
  const [errors, setErrors] = useState<any>({
    startTime: "",
    endTime: "",
    day: "",
  });

  console.log(selectedWorkTime);

  useEffect(() => {
    setSelectedDay(
      WEEK_DAY?.find((item) => item.value === selectedWorkTime?.dayName)
    );
    setStartTime({
      hour: selectedWorkTime?.startTime?.split(":")[0],
      minute: selectedWorkTime?.startTime?.split(":")[1],
    });
    setEndTime({
      hour: selectedWorkTime?.endTime?.split(":")[0],
      minute: selectedWorkTime?.endTime?.split(":")[1],
    });
  }, [selectedWorkTime]);
  const submitHandler = async () => {
    let fieldErrors = { day: "", startTime: "", endTime: "" };

    if (!selectedDay)
      fieldErrors = { ...fieldErrors, day: "انتخاب روز اجباری است" };
    if (!startTime?.hour && !startTime?.minute)
      fieldErrors = {
        ...fieldErrors,
        startTime: "شروع ساعت کاری اجباری است",
      };
    if (!endTime?.hour && !endTime?.minute)
      fieldErrors = {
        ...fieldErrors,
        endTime: "پایان ساعت کاری اجباری است",
      };
    setErrors(fieldErrors);

    if (
      fieldErrors?.day === "" &&
      fieldErrors?.startTime === "" &&
      fieldErrors?.endTime === ""
    ) {
      const result = await updateWorkTime!({
        _id: selectedWorkTime?._id,
        dayName: selectedDay?.value as string,
        dayNumber: selectedDay?._id,
        endTime:
          (endTime?.hour ? endTime?.hour : "00") +
          ":" +
          (endTime?.minute ? endTime?.minute : "00"),
        startTime:
          (startTime?.hour ? startTime?.hour : "00") +
          ":" +
          (startTime?.minute ? startTime?.minute : "00"),
      });
      if (result) {
        setSelectedDay(undefined);
        setStartTime(undefined);
        setEndTime(undefined);
      }
    }
  };

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="create-work-time-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "UPDATE"}
        minWidth={"40rem"}
        minHeight={"22vh"}
      >
        <form>
          <Container>
            <Row className="row-start">
              <Column medium={4} className="dropdown">
                <CustomDropDownSearch
                  itemName="name"
                  items={WEEK_DAY}
                  defaultItem={selectedDay}
                  onSelectItem={(event) => {
                    setSelectedDay(event);
                    setErrors({ ...errors, day: "" });
                  }}
                  placeHolder="روز"
                  label="روز"
                />
              </Column>
              <Column medium={3} className="dropdown">
                <label className="form-label">شروع</label>
                <CustomHourMinutePiker
                  time={startTime as ITime}
                  onChangeTime={(event: ITime) => {
                    setStartTime(event);
                    setErrors({ ...errors, startTime: "" });
                  }}
                  //isDisable={props.defaultValue?.close}
                />
              </Column>
              <Column medium={3} className="dropdown">
                <label className="form-label">پایان</label>
                <CustomHourMinutePiker
                  time={endTime as ITime}
                  onChangeTime={(event: ITime) => {
                    setEndTime(event);
                    setErrors({ ...errors, endTime: "" });
                  }}
                  //isDisable={props.defaultValue?.close}
                />
              </Column>
            </Row>
            <Row className="row-start">
              <Column medium={4} className="dropdown">
                <div className="error">{errors?.day}</div>
              </Column>
              <Column medium={3} className="dropdown">
                <div className="error">{errors?.startTime}</div>
              </Column>
              <Column medium={3} className="dropdown">
                <div className="error">{errors?.endTime}</div>
              </Column>
            </Row>
            <Row className="button-row">
              <Column>
                <CustomButton2
                  title={"ویرایش"}
                  type="primary"
                  onClick={submitHandler}
                  isLoading={loading}
                />
              </Column>
            </Row>
          </Container>
        </form>
      </CustomModal>
    </section>
  );
};

export default Update;
